import Breadcrumbs from 'components/Breadcumbs'
import { useMemo } from 'react'
import { routes } from 'routes/routes'
import { OrganizationalUser, UserModel, UserTypeTab } from 'types'
import { getRoute } from 'utils'

export function UserDetailsBreadcrumbs({
  user,
  route = routes.users,
}: {
  user: UserModel | OrganizationalUser
  route?: string
}) {
  const path = useMemo(() => {
    const role = user.type[0]
    let userType = (role as unknown as UserTypeTab) || UserTypeTab.ORG
    if (role && role.includes('ORG')) {
      userType = UserTypeTab.ORG
    }

    return [
      { href: getRoute(route, { userType }), text: 'Users' },
      {
        text: `${user.firstname} ${user.lastname}`,
      },
    ]
  }, [route, user])

  return <Breadcrumbs path={path} />
}
